import { render } from "./DeliveryApproach.vue?vue&type=template&id=1a128db3"
import script from "./DeliveryApproach.vue?vue&type=script&lang=js"
export * from "./DeliveryApproach.vue?vue&type=script&lang=js"

import "./DeliveryApproach.vue?vue&type=style&index=0&id=1a128db3&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__